import './WebsiteDescriptor.css';

// TODO: do this differently from other descriptors
const WebsiteDescriptor = ({ online, label, code, link, icon, screenshots, children }) => {
	const onlineLabel = online ? 'online' : 'offline';

	return (
		<fieldset className={`WebsiteDescriptor noise ${onlineLabel}`}>
			<legend>{icon && <img src={icon} alt={icon}/>}{label} <span className={onlineLabel + '-label'}>[{onlineLabel}]</span></legend>
			{code && <a href={code}>Source Code</a>}
			{link && <a href={link}>{link}</a>}
			{screenshots &&
				<div className="Screenshots">
					{screenshots.map((screenshot, i) => (
						<img src={screenshot} alt={`Screenshot ${i+1} of ${label}`} />
					))}
				</div>
			}
			{children}
		</fieldset>
	);
};

export default WebsiteDescriptor;
